import React from 'react'
import Game from './game.jsx'
import {store} from '../football_stats.jsx';

/**
 * Compares 2 stats and sorts players by them
 * @param a
 * @param b
 * @return int
 */
function compareByDate(a, b)
{
    if (typeof store.getState().games != 'undefined' && typeof store.getState().games[a] != 'undefined' && typeof store.getState().games[b] != 'undefined') {
        let gameA = store.getState().games[a];
        let gameB = store.getState().games[b];

        //Sorting games by stage if needed...
        if((gameA.stage == 'ChampionshipRound' || gameA.stage == 'RelegationRound') && gameB.stage == 'RegularSeason') {
            return -1;
        } else if(gameA.stage == 'RegularSeason' && (gameB.stage == 'RelegationRound' || gameB.stage == 'ChampionshipRound')) {
            return 1;
        }

        if(gameA.date.sec > gameB.date.sec) {
            return 1;
        } else {
            return -1;
        }
    }

    return 0;
}

function checkStage(gamesStage, rounds, currentRound) {
    let className = "hidden";

    if (gamesStage == 'regularSeason' && typeof rounds[currentRound] != 'undefined' && rounds[currentRound]['stage'] == 'RegularSeason') {
        className = "";
    } else if(gamesStage == 'playoff' && typeof rounds[currentRound] != 'undefined' && (rounds[currentRound]['stage'] == 'ChampionshipRound' || rounds[currentRound]['stage'] == 'RelegationRound')) {
        className = "";
    }

    return className;
}

const RoundGamesWidget = ({
    rounds,
    currentRound,
    gamesStage,
    isRelegationRound = false
}) =>  {

    let currentRoundName = getByLang('Round', 'מחזור', 'الدورة') + " ";
    if(typeof rounds[currentRound] != 'undefined' && rounds[currentRound]['stage'] == 'RegularSeason') {
        currentRoundName = currentRoundName + currentRound;
    } else if (typeof rounds[currentRound] != 'undefined' && rounds[currentRound]['stage'] != 'RegularSeason') {
        currentRoundName = currentRoundName + parseInt(currentRound + 26);
    }

    let playofftextClass = "";

    if (gamesStage == 'playoff' ) {
        playofftextClass = "gamesCurrentRoundPlayoff";

        if(isRelegationRound) {
            currentRoundName = getByLang('Relegation ', 'פלייאוף תחתון', '') + " " + currentRoundName;
        } else {
            currentRoundName = getByLang('Championship ', 'פלייאוף עליון', '') + " " + currentRoundName;
        }
    }

    return (<div className={checkStage(gamesStage, rounds, currentRound)}>
            <div className="roundPicker">
                <i className="fa fa-angle-right" aria-hidden="true" onClick={(e) => (store.dispatch({type: getByLang('NEXT_ROUND', 'PREVIOUS_ROUND', 'NEXT_ROUND'), val: isRelegationRound}))} />

                <div id={"gamesCurrentRound" + currentRound} className={"games-round gamesCurrentRound " + playofftextClass}> { currentRoundName } </div>

                <i className="fa fa-angle-left" aria-hidden="true" onClick={(e) => (store.dispatch({type: getByLang('PREVIOUS_ROUND', 'NEXT_ROUND', 'PREVIOUS_ROUND'), val: isRelegationRound}))} />
            </div>
            <ul className={ "list-unstyled games-round-" + currentRound} >
                {
                    Object.keys(rounds).length && typeof rounds[currentRound] != 'undefined' && Object.keys(rounds[currentRound].games.objects).sort(compareByDate).map((key, index) =>
                        <Game id={key} game={rounds[currentRound].games.objects[key]} />
                    )
                }
            </ul>
        </div>
    )
};

export default RoundGamesWidget
